module.exports = __webpack_public_path__ + "img/Modernisme_Episke_forfattere3.e647a3dd.jpg";